module.exports = __webpack_public_path__ + "static/media/leaf-heart.071d04a1.svg";